// Tab switching functionality
// Handles tab navigation for analysis sections - supports multiple independent tab containers

function initializeTabSwitching() {
  // Find all tab containers (elements containing .tabs)
  const tabContainers = document.querySelectorAll('.tabs');

  console.log('Tab containers found:', tabContainers.length);

  if (tabContainers.length === 0) {
    return; // No tab containers found on this page
  }

  tabContainers.forEach((tabContainer, index) => {
    // Get tabs within this specific container
    const tabs = tabContainer.querySelectorAll('.tab');
    
    // Find the parent container that contains both tabs and tab-content
    const parentContainer = tabContainer.closest('.card-body, .container, .section, [data-tab-group]') || tabContainer.parentElement;
    const tabContents = parentContainer.querySelectorAll('.tab-content');

    console.log(`Container ${index}: tabs=${tabs.length}, contents=${tabContents.length}`);

    if (tabs.length === 0 || tabContents.length === 0) {
      return; // No tabs or content found in this container
    }

    // Initialize: hide all contents first, then show active tab content
    tabContents.forEach(content => {
      content.classList.add('hidden');
      content.style.display = 'none';
    });

    // Show content for active tab on page load
    const activeTab = tabContainer.querySelector('.tab-active');
    if (activeTab) {
      const activeTargetTab = activeTab.getAttribute('data-tab');
      const activeContent = parentContainer.querySelector(`[data-tab-content="${activeTargetTab}"]`);
      if (activeContent) {
        activeContent.classList.remove('hidden');
        activeContent.style.display = 'block';
      }
    }

    tabs.forEach(tab => {
      // Remove any existing listeners to prevent duplicates
      const newTab = tab.cloneNode(true);
      tab.parentNode.replaceChild(newTab, tab);

      newTab.addEventListener('click', function(e) {
        e.preventDefault();
        const targetTab = this.getAttribute('data-tab');

        console.log('Tab clicked:', targetTab);

        if (!targetTab) return;

        // Only affect tabs and content within this container
        const containerTabs = tabContainer.querySelectorAll('.tab');
        const containerTabContents = parentContainer.querySelectorAll('.tab-content');

        console.log('Affecting tabs:', containerTabs.length, 'contents:', containerTabContents.length);

        // Remove active classes within this container only
        containerTabs.forEach(t => {
          t.classList.remove('tab-active', 'btn-primary');
          t.classList.add('btn-ghost');
        });
        containerTabContents.forEach(content => {
          content.classList.add('hidden');
          content.style.display = 'none';
        });

        // Add active class to clicked tab
        this.classList.add('tab-active', 'btn-primary');
        this.classList.remove('btn-ghost');

        // Show corresponding content within this container
        const targetContent = parentContainer.querySelector(`[data-tab-content="${targetTab}"]`);
        console.log('Target content found:', !!targetContent, targetTab);
        if (targetContent) {
          targetContent.classList.remove('hidden');
          targetContent.style.display = 'block';
          console.log('Content shown for:', targetTab);
        }
      });
    });
  });
}

// Initialize on DOM load and Turbo load for SPA navigation
document.addEventListener('turbo:load', initializeTabSwitching);
